import type React from 'react'
import { useLayoutEffect } from 'react'
import { createPortal } from 'react-dom'

export function PopoverPortal({
  container,
  element,
  scoutElement,
  children,
}: {
  container: Element
  element: Element
  scoutElement: Element
  children: React.ReactNode
}) {
  useLayoutEffect(() => {
    container.appendChild(element)
    container.appendChild(scoutElement)
    return () => {
      container.removeChild(element)
      container.removeChild(scoutElement)
    }
  }, [container, element, scoutElement])

  return createPortal(children, element)
}
